/* eslint-disable */
import React from 'react';
import { BaseFilter, ShowTitleByLowerTitle } from './Scaffolding';
import {
    TextField,
    Datagrid,
    Show,
    Create,
    BooleanField,
    SimpleForm,
    Edit,
    DateField,
    SimpleShowLayout,
    NumberField,
} from 'react-admin';
import { SwList } from '../lib/SwList';
import { useAzureADGroups } from '../msal/useAzureADGroups';
import { ReadOnlyContext } from '../lib/context/ReadOnlyContext';
import { EditToolbar } from '../layout/EditToolbar';
import { BooleanInput, TextInput } from '../lib/wrappers/Inputs';

export const CreditValueLabels = {
    pageTitle: 'Credit Values',
    creditvalue: 'Credit value',
};

export const CreditValueList = (props) => {
    const { canEditStaticData } = useAzureADGroups();
    return (
        <ReadOnlyContext.Provider value={!canEditStaticData}>
            <SwList
                {...props}
                title={CreditValueLabels.pageTitle}
                filters={<BaseFilter />}
            >
                <Datagrid
                    rowClick="edit"
                    bulkActionButtons={!canEditStaticData ? false : undefined}
                >
                    <TextField source="id" />
                    <TextField source="Title" />
                    <TextField
                        label={CreditValueLabels.creditvalue}
                        source="creditvalue"
                    />
                    <BooleanField source="current" />
                </Datagrid>
            </SwList>
        </ReadOnlyContext.Provider>
    );
};

export const CreditValueEdit = (props) => {
    const { canEditStaticData } = useAzureADGroups();

    return (
        <ReadOnlyContext.Provider value={!canEditStaticData}>
            <Edit title={<ShowTitleByLowerTitle />} {...props} redirect="edit">
                <SimpleForm toolbar={<EditToolbar />}>
                    <TextInput source="id" disabled />
                    <TextInput source="title" />
                    <TextInput
                        label={CreditValueLabels.creditvalue}
                        source="creditvalue"
                    />
                    <BooleanInput source="current" />
                    <TextInput source="created_at" disabled />
                    <TextInput source="updated_at" disabled />
                </SimpleForm>
            </Edit>{' '}
        </ReadOnlyContext.Provider>
    );
};

export const CreditValueCreate = (props) => (
    <Create {...props} redirect="edit">
        <SimpleForm>
            <TextInput source="title" />
            <TextInput
                label={CreditValueLabels.creditvalue}
                source="creditvalue"
            />
            <BooleanInput source="current" />
        </SimpleForm>
    </Create>
);

export const CreditValueShow = (props) => (
    <Show title={<ShowTitleByLowerTitle />} {...props}>
        <SimpleShowLayout>
            <TextField source="id" />
            <TextField source="title" />
            <NumberField
                label={CreditValueLabels.creditvalue}
                source="creditvalue"
            />
            <BooleanField source="current" />
            <TextField source="created_at" />
            <DateField source="updated_at" />
        </SimpleShowLayout>
    </Show>
);
